(function($) {

    var oldHash;


    const $filterLinks = $('.press-items__filters a');
    const $pressItems = $('[data-press-categories]');

    if($filterLinks.length < 1){
        return;
    }

    function showAllItems(){
        $pressItems.fadeIn(300).addClass('active');
    }

    $filterLinks.on('click', function(event) {
        event.preventDefault();

        $filterLinks.removeClass('active');

        $(this).addClass('active');
        var href = $(this).attr("href");
        var hash = href.substr(href.indexOf("#"));

        if(hash === '#all'){
            showAllItems();
        }else{
            let $oldActive = $(`[data-press-categories*="${oldHash}"]`);
            let $newActive = $(`[data-press-categories*="${hash}"]`);

            if ( $oldActive.hasClass('active') ) {
                $oldActive.removeClass('active').fadeOut(300, function() {
                    $newActive.fadeIn(300).addClass('active');
                });
            } else {
                $pressItems.not($newActive).fadeOut(300, function(){
                    $newActive.fadeIn(300).addClass('active');
                });

            }

        }


        if(history.pushState) {
            history.pushState(null, null, hash);
        }
        else {
            location.hash = hash;
        }

        oldHash = hash;
        console.log( oldHash );
    });

    var initialHash = window.location.hash;
    $pressItems.hide();

    if ( initialHash && !initialHash.match(/\//) ) {
        $filterLinks.filter('[href*="'+initialHash+'"]').eq(0).click();
        oldHash = initialHash;
    } else {
        $filterLinks.eq(0).click();
    }

})(jQuery);